import { useSelector } from 'react-redux'
import { MACROECONOMICS_TAB } from './constant'
import { Fdi } from './fdi'
import { Gdp } from './gdp'
import { ImportExport } from './importExport'
import { selectActiveTab } from './store/slice'

const mapContent = {
  [MACROECONOMICS_TAB.GDP.key]: <Gdp />,
  [MACROECONOMICS_TAB.FDI.key]: <Fdi />,
  [MACROECONOMICS_TAB.IMPORT_EXPORT.key]: <ImportExport />,
}

export const Content = () => {
  const activeTab = useSelector(selectActiveTab)

  return mapContent[activeTab]
}
